<template>
  <dl
    :class="{ 'accordion--opened': isOpened, 'accordion--events': isEvents }"
    :id="`post_id_${list.id}`"
  >
    <dt @click="toggleAccordion">
      <span>{{ list.title.rendered }}</span>
    </dt>
    <transition
      name="accordion"
      @before-enter="accordion.beforeEnter"
      @enter="accordion.enter"
      @before-leave="accordion.beforeLeave"
      @leave="accordion.leave"
    >
      <dd v-if="isOpened" v-html="list.content.rendered" class="wp-content" />
    </transition>
  </dl>
</template>

<script lang="ts">
import { ref, defineComponent, onMounted, nextTick, watch } from 'vue'
import { useRoute } from 'vue-router'

export default defineComponent({
  name: 'FaqLists',
  props: {
    list: {
      type: Object
    },
    isEvents: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const isOpened = ref(false)

    const toggleAccordion = () => {
      isOpened.value = !isOpened.value
    }
    const route = useRoute()

    const accordion = {
      beforeEnter(el: any) {
        el.style.height = '0'
      },
      enter(el: any) {
        el.style.height = el.scrollHeight + 'px'
      },
      beforeLeave(el: any) {
        el.style.height = el.scrollHeight + 'px'
      },
      leave(el: any) {
        el.style.height = '0'
      }
    }
    const scrollToHash = async () => {
      const targetId = route.hash
      if (!targetId) return
      if (!!props.list && `#post_id_${props.list.id}` == targetId) {
        isOpened.value = true
      }
      await nextTick()
      const targetEl = document.querySelector(targetId) as HTMLElement

      const targetOffsetTop =
        targetEl.getBoundingClientRect().top + window.scrollY

      targetEl.querySelector('dd')?.addEventListener('transitionend', () => {
        window.scrollTo({ top: targetOffsetTop })
      })
    }
    onMounted(() => {
      scrollToHash()
    })

    watch(
      () => route.hash,
      () => {
        isOpened.value = false
        nextTick(() => {
          scrollToHash()
        })
      }
    )

    return {
      isOpened,
      toggleAccordion,
      accordion
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

dl {
  // line-height: 1.64;
  border-bottom: 1px solid #e4e4e4;
  // transition: padding-bottom 0.4s;
  &:first-of-type {
    // margin-top: 20px;
    margin-top: 2px;
    @include mixins.media() {
      margin-top: 6px;
    }
  }
}
dt {
  position: relative;
  padding: 14px 37px 14px 30px;
  cursor: pointer;
  transition: margin-bottom 0.4s;
  &::before,
  &::after {
    position: absolute;
  }
  &::before {
    color: #c6c6c6;
    // font-family: Arial, Helvetica, sans-serif;
    font-family: Arial, sans-serif;
    font-size: 24px;
    font-weight: bold;
    line-height: 30px;
    // top: 0;
    left: 0;
    content: 'Q';
  }
  &::after {
    background-color: var.$color-main;
    width: 20px;
    height: 20px;
    top: 50%;
    right: 0;
    content: '';
    border-radius: 50%;
    transform: translateY(-50%);
  }
}
.accordion--events dt::before {
  color: var.$color-main;
}
span {
  &::before,
  &::after {
    position: absolute;
    background-color: #fff;
    width: 9px;
    height: 2px;
    margin-right: 5.5px;
    top: 50%;
    right: 0;
    z-index: 1;
    content: '';
    border-radius: 5px;
  }
  &::before {
    transform: translateY(-50%);
    transition: background-color 0.2s;
  }
  &::after {
    transform-origin: top;
    transform: rotate(90deg) translateY(-50%);
    transition: transform 0.2s;
  }
}
dd {
  position: relative;
  line-height: 1.64;
  font-size: 1.4rem;
  // padding: 12px 0 24px 30px;
  padding-left: 30px;
  overflow: hidden;
  transition: height 0.4s, opacity 0.4s;
  &::after {
    position: absolute;
    color: #c6c6c6;
    font-family: Arial, sans-serif;
    font-size: 24px;
    font-weight: bold;
    line-height: 30px;
    top: 0;
    left: 0;
    content: 'A';
  }
}
.accordion--events dd::after {
  color: var.$color-primary;
}

.accordion--opened {
  // padding-bottom: 24px;
  padding-bottom: 1px; // モバイルで高さが確保されないので1pxだけ
  dt {
    margin-bottom: 12px;
  }
  span {
    &::before {
      background-color: transparent;
    }
    &::after {
      // transform-origin: top;
      transform: translateY(-50%);
    }
  }
}

// .accordion-enter-active,
// .accordion-leave-active {
// transition: opacity 0.2s;
// transition: height 0.2s, opacity 0.2s;
// }
.accordion-enter,
.accordion-leave-to {
  opacity: 0;
}
</style>
